import { reduxDispatcher } from 'lib/Dispatcher';
import { touch as touchAction } from 'reducers/touch';

export function touch(key: string) {
  reduxDispatcher.dispatch(touchAction(key));
}
